import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGraphqlLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.graphql-icon-st1{fill:currentColor;}\n"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "graphql-icon-st1",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.9995 1.65723L20.957 6.82885V17.1721L11.9995 22.3437L3.04199 17.1721V6.82885L11.9995 1.65723ZM4.04704 7.40912V15.0065L10.6266 3.61042L4.04704 7.40912ZM11.9995 3.24255L4.41491 16.3795H19.5841L11.9995 3.24255ZM18.5791 17.3845H5.41996L11.9995 21.1832L18.5791 17.3845ZM19.952 15.0065L13.3724 3.61042L19.952 7.40912V15.0065Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "graphql-icon-st1",
			d: "M11.9996 4.35372C13.1687 4.35372 14.1164 3.40599 14.1164 2.23692C14.1164 1.06784 13.1687 0.120117 11.9996 0.120117C10.8305 0.120117 9.88281 1.06784 9.88281 2.23692C9.88281 3.40599 10.8305 4.35372 11.9996 4.35372Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "graphql-icon-st1",
			d: "M20.4547 9.23555C21.6238 9.23555 22.5715 8.28783 22.5715 7.11875C22.5715 5.94968 21.6238 5.00195 20.4547 5.00195C19.2856 5.00195 18.3379 5.94968 18.3379 7.11875C18.3379 8.28783 19.2856 9.23555 20.4547 9.23555Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "graphql-icon-st1",
			d: "M20.4547 18.9982C21.6238 18.9982 22.5715 18.0505 22.5715 16.8814C22.5715 15.7124 21.6238 14.7646 20.4547 14.7646C19.2856 14.7646 18.3379 15.7124 18.3379 16.8814C18.3379 18.0505 19.2856 18.9982 20.4547 18.9982Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "graphql-icon-st1",
			d: "M11.9996 23.8801C13.1687 23.8801 14.1164 22.9324 14.1164 21.7633C14.1164 20.5942 13.1687 19.6465 11.9996 19.6465C10.8305 19.6465 9.88281 20.5942 9.88281 21.7633C9.88281 22.9324 10.8305 23.8801 11.9996 23.8801Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "graphql-icon-st1",
			d: "M3.54356 18.9982C4.71263 18.9982 5.66036 18.0505 5.66036 16.8814C5.66036 15.7124 4.71263 14.7646 3.54356 14.7646C2.37448 14.7646 1.42676 15.7124 1.42676 16.8814C1.42676 18.0505 2.37448 18.9982 3.54356 18.9982Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "graphql-icon-st1",
			d: "M3.54356 9.23555C4.71263 9.23555 5.66036 8.28783 5.66036 7.11875C5.66036 5.94968 4.71263 5.00195 3.54356 5.00195C2.37448 5.00195 1.42676 5.94968 1.42676 7.11875C1.42676 8.28783 2.37448 9.23555 3.54356 9.23555Z"
		})
	]
});
export default SvgGraphqlLogo;
